import { useState } from 'react';
import ReactModal from 'react-modal';
import { useDispatch, useSelector } from 'react-redux';

import { noShowAppointment } from 'actions/appointments';
import Button from 'atoms/button';
import Checkbox from 'atoms/checkbox';
import { closeDrawer, toggleNoShowModal } from 'store/reducers/ui';

export default function NoShowModal() {
  const dispatch = useDispatch();
  const { appointmentNoShowModal } = useSelector((state) => state.ui);
  const { user, uuid } = appointmentNoShowModal.appointment;
  const [waiveFee, setWaiveFee] = useState(false);

  const onClose = () => {
    dispatch(toggleNoShowModal({ isOpen: false, appointment: null }));
  };

  const onConfirm = async () => {
    const noShow = await dispatch(noShowAppointment(uuid, waiveFee));
    if (noShow.success) {
      onClose();
      dispatch(closeDrawer());
    }
  };
  return (
    <ReactModal
      ariaHideApp={false}
      isOpen={appointmentNoShowModal.isOpen}
      onRequestClose={onClose}
      className="no-show-modal"
    >
      <div className="text-center no-show-modal">
        <h2 className="mb-12 f26">Confirm No Show</h2>
        <p className=" margin-center">{`Are you sure you want to mark this appointment as a no show? ${user.firstName} will be charged a $50 fee.`}</p>
        <div className="mt-15 mb-35 checkbox-container">
          <Checkbox
            id="apply"
            size="small"
            value={!waiveFee}
            disableInternalCheck
            variant="radio"
            className="mb-12"
            onClick={() => setWaiveFee(false)}
          >
            <p className="ml-10">Apply $50 No Show Fee</p>
          </Checkbox>
          <Checkbox
            id="waive"
            size="small"
            value={waiveFee}
            disableInternalCheck
            variant="radio"
            onClick={() => setWaiveFee(true)}
          >
            <p className="ml-10">Waive Fee</p>
          </Checkbox>
        </div>
        <div className="flex-row justify-center">
          <Button text="Confirm" onClick={onConfirm} className="mr-20" />
          <Button text="Cancel" onClick={onClose} variant="reverse" />
        </div>
      </div>
    </ReactModal>
  );
}
